import { KatexRenderer, type KatexRendererProps } from '@shared/components';
import { NodeViewWrapper } from '@tiptap/react';

export type LatexRendererProps = KatexRendererProps;

export default function LatexRenderer(props: Readonly<LatexRendererProps>) {
  return (
    <NodeViewWrapper as='span'>
      <KatexRenderer {...props} />
    </NodeViewWrapper>
  );
}
